export class PluginHelper {
    public static getPluginAppCategory(url: string): string {
        if (!url) {
            return '';
        }
        
        url = url.substring(0, url.lastIndexOf('/'));
        return url.substring(url.lastIndexOf('/') + 1);
    }
}